var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-mobile-full-screen-container",
    [
      _c(
        "w-card",
        { staticClass: "grow text-area-modal", attrs: { "max-width": "700" } },
        [
          _vm.title
            ? _c("w-card-title", { staticClass: "blue" }, [
                _vm._v(" " + _vm._s(_vm.title) + " "),
              ])
            : _vm._e(),
          _c(
            "w-scroll-view",
            { staticClass: "grow shrink", attrs: { tag: "w-card-content" } },
            [
              _c(
                "w-row",
                { staticClass: "grow" },
                [
                  _c(
                    "w-col",
                    { staticClass: "grow", attrs: { xs: "12" } },
                    [
                      _vm.showEditor
                        ? _c("w-editor", {
                            attrs: { height: "600", value: _vm.text },
                            on: {
                              input: function ($event) {
                                return _vm.onInput($event)
                              },
                              "cursor-position": function ($event) {
                                return _vm.$emit("cursor-position", $event)
                              },
                            },
                          })
                        : _c("w-textarea", {
                            ref: "textarea",
                            attrs: {
                              height: "600",
                              name: _vm.name,
                              label: _vm.label,
                            },
                            on: {
                              keyup: function ($event) {
                                return _vm.onKeyUp($event)
                              },
                              mouseup: function ($event) {
                                return _vm.onMouseUp()
                              },
                              focus: function ($event) {
                                return _vm.onFocus()
                              },
                            },
                            model: {
                              value: _vm.text,
                              callback: function ($$v) {
                                _vm.text = $$v
                              },
                              expression: "text",
                            },
                          }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._t("below-editor"),
            ],
            2
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.cancelText) + " ")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  ref: "ok",
                  attrs: { icon: "save" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm()
                    },
                    keydown: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        if (
                          $event.ctrlKey ||
                          $event.shiftKey ||
                          $event.altKey ||
                          $event.metaKey
                        )
                          return null
                        return _vm.confirm()
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                        )
                          return null
                        if (
                          $event.ctrlKey ||
                          $event.shiftKey ||
                          $event.altKey ||
                          $event.metaKey
                        )
                          return null
                        return _vm.confirm()
                      },
                    ],
                  },
                },
                [_vm._v(" " + _vm._s(_vm.okText) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }